import type { UeberfachlicheKompetenz } from './ueberfachliche-kompetenz'
import { LumiaColor } from './lumia-color'

const UEBERFACHLICHE_KOMPETENZ_COLORS = {
  '9fa78775-f607-4f2c-bc48-00054053fb27': LumiaColor.MelancholischerSchiffskapitaen, // Selbstreflexion
  'b2f86c59-b679-45b5-9123-733f17eeca0e': LumiaColor.AyahuascaNachher, // Eigenständigkeit
  '70ac2a85-e18f-4a56-a326-4c97a3ff088d': LumiaColor.Vigoletto, // Selbstständigkeit
  'a92882c9-b54e-41c0-ae27-2d79bfc44e5e': LumiaColor.BlueSpanishEyes, // Aufgaben und Probleme lösen
  '9af0b6c6-8b88-4d80-99a4-b78119c68ae5': LumiaColor.AyahuascaVorher, // Informationen nutzen
  '0c0276e1-d735-4e68-8b2b-cac101a22c5a': LumiaColor.RasenmaeherRueckstaende, // Sprachfähigkeit
  '5ddc07af-3753-45bb-89fc-2de5dac298f8': LumiaColor.AfterRooftopParty, // Umgang mit Vielfalt
  'd268872d-38b2-4c0c-b034-5fa59a766e8c': LumiaColor.NichtWeiss, // Konfliktfähigkeit
  '4b81defa-779d-4f87-98c2-b2c551383fb5': LumiaColor.TouristinnenRot, // Dialog- und Kooperationsfähigkeit
} as const satisfies Record<string, LumiaColor>

export function colorForUeberfachlicheKompetenz(
  kompetenz?: Pick<UeberfachlicheKompetenz, 'id'>,
): LumiaColor | undefined {
  if (!kompetenz) {
    return undefined
  }
  return UEBERFACHLICHE_KOMPETENZ_COLORS[
    kompetenz.id as keyof typeof UEBERFACHLICHE_KOMPETENZ_COLORS
  ]
}
